import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Collapse } from "reactstrap";
import { Link } from "react-router-dom";
import withRouter from "../Common/withRouter";
import classname from "classnames";

// i18n
import { withTranslation } from "react-i18next";

import { connect } from "react-redux";

const Navbar = (props) => {
	const [empresa, setEmpresa] = useState(false);
	const [comprobante, setComprobante] = useState(false);
	const [administracion, setAdministracion] = useState(false);
	const [impuestos, setImpuestos] = useState(false);
	const [inventarios, setInventario] = useState(false);
	const [mercadeo, setMercadeo] = useState(false);
	const [maopaConsumo, setMapaConsumo] = useState(false);
	const [envioCorreos, setEnvioCorreos] = useState(false);
	const [presupuestos, setPresupuestos] = useState(false);
	const [seguridad, setSeguridad] = useState(false);

	// Close all dropdowns
	const closeAll = () => {
		setEmpresa(false);
		setComprobante(false);
		setAdministracion(false);
		setImpuestos(false);
		setInventario(false);
		setMercadeo(false);
		setMapaConsumo(false);
		setEnvioCorreos(false);
		setPresupuestos(false);
		setSeguridad(false);
	};



	useEffect(() => {
		closeAll();
		const pathName = process.env.PUBLIC_URL + props.router.location.pathname;

		var matchingMenuItem = null;
		var ul = document.getElementById("navigation");
		var items = ul.getElementsByTagName("a");
		removeActivation(items);
		for (var i = 0; i < items.length; ++i) {
			if (pathName === items[i].pathname) {
				matchingMenuItem = items[i];
				break;
			}
		}
		if (matchingMenuItem) {
			activateParentDropdown(matchingMenuItem);
		}
	});

	const removeActivation = (items) => {
		for (var i = 0; i < items.length; ++i) {
			var item = items[i];
			const parent = items[i].parentElement;
			if (item && item.classList.contains("active")) {
				item.classList.remove("active");
			}
			if (parent) {
				if (parent.classList.contains("active")) {
					parent.classList.remove("active");
				}
			}
		}
	};

	function activateParentDropdown(item) {
		item.classList.add("active");
		const parent = item.parentElement;
		if (parent) {
			parent.classList.add("active"); // li
			const parent2 = parent.parentElement;
			parent2.classList.add("active"); // li
			const parent3 = parent2.parentElement;
			if (parent3) {
				parent3.classList.add("active"); // li
				const parent4 = parent3.parentElement;
				if (parent4) {
					parent4.classList.add("active"); // li
					const parent5 = parent4.parentElement;
					if (parent5) {
						parent5.classList.add("active"); // li
						const parent6 = parent5.parentElement;
						if (parent6) {
							parent6.classList.add("active"); // li
						}
					}
				}
			}
		}
		return false;
	}

	return (
		<React.Fragment>
			<div className="container-fluid">
				<div className="topnav">
					<nav
						className="navbar navbar-light navbar-expand-lg topnav-menu"
						id="navigation">
						<Collapse
							isOpen={props.leftMenu}
							className="navbar-collapse"
							id="topnav-menu-content">
							<ul className="navbar-nav">
								<li className="nav-item">
									<Link className="nav-link" to="/portal">
										<i className="ti-dashboard"></i> {props.t("Dashboard")}
									</Link>
								</li>

								<li className="nav-item dropdown">
									<Link
										to="/#"
										onClick={(e) => {
											e.preventDefault();
											const next = !administracion;
											closeAll();
											setAdministracion(next);
										}}
										className="nav-link dropdown-toggle arrow-none">
										<i className="ti-briefcase"></i> {props.t("Administracion")}
									</Link>
									<div
										className={classname("dropdown-menu dropdown-menu-left", {
											show: administracion,
										})}>
										<Link to="/portal/registro" className="dropdown-item">
											{props.t("Registrar Usuarios")}
										</Link>
										<Link to="/portal/usuarios" className="dropdown-item">
											{props.t("Listar Usuarios")}
										</Link>
									</div>
								</li>

								<li className="nav-item dropdown">
									<Link
										to="/#"
										onClick={(e) => {
											e.preventDefault();
											const next = !seguridad;
											closeAll();
											setSeguridad(next);
										}}
										className="nav-link dropdown-toggle arrow-none">
										<i className="ti-shield"></i> {props.t("Seguridad")}
									</Link>
									<div
										className={classname("dropdown-menu dropdown-menu-left", {
											show: seguridad,
										})}>
										<Link to="/portal/roles" className="dropdown-item">
											{props.t("Roles y Permisos")}
										</Link>
										<Link to="/portal/menus" className="dropdown-item">
											{props.t("Gestión de Menús")}
										</Link>
									</div>
								</li>

								<li className="nav-item dropdown">
									<Link
										to="/#"
										onClick={(e) => {
											e.preventDefault();
											const next = !empresa;
											closeAll();
											setEmpresa(next);
										}}
										className="nav-link dropdown-toggle arrow-none">
										<i className="ti-briefcase"></i> {props.t("Empresa")}
									</Link>
									<div
										className={classname("dropdown-menu dropdown-menu-left", {
											show: empresa,
										})}>
										<Link
											to="/portal/consultar-empresas"
											className="dropdown-item">
											{props.t("Consultar Empresas")}
										</Link>
									</div>
								</li>

								<li className="nav-item dropdown">
									<Link
										to="/#"
										onClick={(e) => {
											e.preventDefault();
											const next = !comprobante;
											closeAll();
											setComprobante(next);
										}}
										className="nav-link dropdown-toggle arrow-none">
										<i className="ti-briefcase"></i> {props.t("Comprobantes")}
									</Link>
									<div
										className={classname("dropdown-menu dropdown-menu-left", {
											show: comprobante,
										})}>
										<Link
											to="/portal/consultar-comprobantes"
											className="dropdown-item">
											{props.t("Consultar Comprobantes")}
										</Link>
										<Link
											to="/portal/reporte-faltantas"
											className="dropdown-item">
											{props.t("Reporte folios faltantes")}
										</Link>
										<Link
											to="/portal/analisis-ventas"
											className="dropdown-item">
											{props.t("Analisis Ventas")}
										</Link>
										<Link
											to="/portal/medios-pagos"
											className="dropdown-item">
											{props.t("Analisis medios de pago")}
										</Link>
										<Link
											to="/portal/terceros"
											className="dropdown-item">
											{props.t("Analisis ventas X terceros")}
										</Link>
									</div>
								</li>



								<li className="nav-item dropdown">
									<Link
										to="/#"
										onClick={(e) => {
											e.preventDefault();
											const next = !impuestos;
											closeAll();
											setImpuestos(next);
										}}
										className="nav-link dropdown-toggle arrow-none">
										<i className="ti-briefcase"></i> {props.t("Impuestos")}
									</Link>
									<div
										className={classname("dropdown-menu dropdown-menu-left", {
											show: impuestos,
										})}>
										<Link
											to="/portal/impuestos-generales"
											className="dropdown-item">
											{props.t("Impuestos Globales")}
										</Link>

									</div>
								</li>


								<li className="nav-item dropdown">
									<Link
										to="/#"
										onClick={(e) => {
											e.preventDefault();
											const next = !inventarios;
											closeAll();
											setInventario(next);
										}}
										className="nav-link dropdown-toggle arrow-none">
										<i className="ti-briefcase"></i> {props.t("Inventarios")}
									</Link>
									<div
										className={classname("dropdown-menu dropdown-menu-left", {
											show: inventarios,
										})}>
										<Link
											to="/portal/analisis-articulos"
											className="dropdown-item">
											{props.t("Analisis Articulos")}
										</Link>

									</div>
								</li>

								<li className="nav-item dropdown">
									<Link
										to="/#"
										onClick={(e) => {
											e.preventDefault();
											const next = !mercadeo;
											closeAll();
											setMercadeo(next);
										}}
										className="nav-link dropdown-toggle arrow-none">
										<i className="ti-briefcase"></i> {props.t("Mercadeo")}
									</Link>
									<div
										className={classname("dropdown-menu dropdown-menu-left", {
											show: mercadeo,
										})}>
										<Link
											to="/portal/perfil-cliente"
											className="dropdown-item">
											{props.t("Perfil de Cliente 360°")}
										</Link>
										<Link
											to="/portal/mapa-consumo"
											className="dropdown-item">
											{props.t("Mapa de Consumo")}
										</Link>
									</div>

								</li>

								<li className="nav-item dropdown">
									<Link
										to="/#"
										onClick={(e) => {
											e.preventDefault();
											const next = !envioCorreos;
											closeAll();
											setEnvioCorreos(next);
										}}
										className="nav-link dropdown-toggle arrow-none">
										<i className="ti-email"></i> {props.t("Envío de correos")}
									</Link>
									<div
										className={classname("dropdown-menu dropdown-menu-left", {
											show: envioCorreos,
										})}>
										<Link to="/portal/envio-correos/analisis" className="dropdown-item">
											{props.t("Análisis")}
										</Link>
										<Link to="/portal/envio-correos/errores" className="dropdown-item">
											{props.t("Errores por emisor")}
										</Link>
										<Link to="/portal/envio-correos/reenvio-masivo" className="dropdown-item">
											{props.t("Reenvío masivo")}
										</Link>
										<Link to="/portal/envio-correos/bandeja" className="dropdown-item">
											{props.t("Bandeja de envíos")}
										</Link>
										<Link to="/portal/envio-correos/reportes" className="dropdown-item">
											{props.t("Reportes de entregabilidad")}
										</Link>
									</div>
								</li>

								<li className="nav-item dropdown">
									<Link
										to="/#"
										onClick={(e) => {
											e.preventDefault();
											const next = !presupuestos;
											closeAll();
											setPresupuestos(next);
										}}
										className="nav-link dropdown-toggle arrow-none">
										<i className="ti-target"></i> {props.t("Presupuestos")}
									</Link>
									<div
										className={classname("dropdown-menu dropdown-menu-left", {
											show: presupuestos,
										})}>
										<Link to="/portal/presupuestos" className="dropdown-item">
											{props.t("Mis presupuestos")}
										</Link>
										<Link to="/portal/presupuestos/nuevo" className="dropdown-item">
											{props.t("Nuevo presupuesto")}
										</Link>
										<Link to="/portal/presupuestos/comparativo" className="dropdown-item">
											{props.t("Comparativo vs Ventas")}
										</Link>
									</div>
								</li>

							</ul>
						</Collapse>
					</nav>
				</div>
			</div>
		</React.Fragment>
	);
};

Navbar.propTypes = {
	leftMenu: PropTypes.any,
	location: PropTypes.any,
	menuOpen: PropTypes.any,
	t: PropTypes.any,
};

const mapStatetoProps = (state) => {
	const { leftMenu } = state.Layout;
	return { leftMenu };
};

export default withRouter(
	connect(mapStatetoProps, {})(withTranslation()(Navbar))
);
